import { render, staticRenderFns } from "./SpotsImport.global.vue?vue&type=template&id=680bb8c3&lang=pug&"
import script from "./SpotsImport.global.vue?vue&type=script&lang=ts&"
export * from "./SpotsImport.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports